export const convertToDate = (string) => {
    return string? (string.substring(6, 8) + '/' + string.substring(4, 6) + '/' + string.substring(2, 4)) : 'no-date'
}

export const convertToDateForMagica = (string) => {
    return string.substring(6, 8)  + '/' + string.substring(4, 6) + '/' + string.substring(0, 4)
}